import React, {useState} from 'react'
import cnBind from 'classnames/bind'
import {useFormik} from 'formik';
import {toast} from 'react-toastify';
import {GxForm, GxIcon, GxSpinner} from '@garpix/garpix-web-components-react';
import {useStoreon} from 'storeon/react';
import { authApiReq } from '@/api/interfaces/requests';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss'
import {ReactComponent as Logo} from '../../../../assets/Base/Logo.svg';
import Fon from '../../../../assets/Base/AuthorizationFon.svg';
import {PasswordIcon, UserIcon} from '../../../../assets';
import {validationSchemaAuth} from '../../helpers';
import {NAME_STATUS_API_ORDER} from '../../../Applications/consts';
import {TYPE} from '../../const';

const AuthorizationForm = () => {
  const cn = cnBind.bind(styles);
  const { dispatch } = useStoreon<State, Events>('currentUser');
  const [spinnerFlag, setSpinnerFlag] = useState<boolean>(false);
  // ! Накрылись роуты, позже разберусь почему
  // let navigate = useNavigate();

  const [flag, setFlag] = useState({
    [TYPE.LOGIN]: false,
    [TYPE.PASS]: false
  });

  const getUser = async () => {
    const data = await api.user.getCurrentUser();
    dispatch('currentUser/get', data)
    return data;
  }

  const login = (params: authApiReq.ILoginReq) => {
    setSpinnerFlag(!spinnerFlag);
    const response = api.auth.login(params);
    toast.promise(
      response,
      {
        error: {
          render(res: Record<string, any>) {
            setSpinnerFlag(false);
            const {status} = res.data.response;
            if (status === 500) {
              return `${NAME_STATUS_API_ORDER.LOGIN.ERROR_500} ${status}`
            }
            return NAME_STATUS_API_ORDER.LOGIN.ERROR
          }
        }
      }).then(() => {
      getUser();
      window.location.reload();
    })
  }
  const formik = useFormik({
    initialValues: {
      username: '',
      password: ''
    },
    validationSchema: validationSchemaAuth,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit(data) {
      login(data);
    }
  });

  function removeClass(e: Record<string, any>, type: string) {
    if (e.target.value === '') {
      if (type === TYPE.LOGIN) setFlag({...flag, login: false})
      if (type === TYPE.PASS) setFlag({...flag, pass: false})
    }
  }

  return (
    <div className={styles['wrapper']}>
      <img className={styles['wrapper--fon']} src={Fon} alt='fon'/>
      <div className={styles['container']}>
        <div className={styles['img']}/>
        <div className={styles['login-content']}>
          <GxForm className={styles['form']} onGx-submit={() => formik.submitForm()}>
            <Logo className={styles['form--logotype']}/>
            <h2 className={styles['form--title']}>Вход</h2>
            <div
              className={cn({
                'form-group': true,
                'form-group--login': true,
                'focus': flag.login,
                'form-group--error': formik.errors.username
              })}
              onFocus={() => setFlag({...flag, login: true})}
              onBlur={(e) => removeClass(e, TYPE.LOGIN)}
            >
              <div className={styles['block']}>
                <GxIcon
                  className={cn({
                    'block--icon': true,
                    'block--error': formik.errors.username
                  })}
                  src={UserIcon}/>
              </div>
              <div
                className={styles['form-block']}>
                <h5 className={styles['form-block--title']}>Логин</h5>
                <input
                  onChange={formik.handleChange}
                  name="username"
                  value={formik.values.username}
                  className={styles['form-block--input']}/>
              </div>
              {formik.errors.username && (
                <div className={styles['error']}>{formik.errors.username}</div>
              )}
            </div>
            <div
              className={cn({
                'form-group': true,
                'form-group--pass': true,
                'focus': flag.pass,
                'form-group--error': formik.errors.password
              })}
              onFocus={() => setFlag({...flag, pass: true})}
              onBlur={(e) => removeClass(e, TYPE.PASS)}
            >
              <div className={styles['block']}>
                <GxIcon
                  className={cn({
                    'block--icon': true,
                    'block--error': formik.errors.password
                  })}
                  src={PasswordIcon}
                />
              </div>
              <div className={styles['form-block']}>
                <h5 className={styles['form-block--title']}>Пароль</h5>
                <input
                  onChange={formik.handleChange}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  className={styles['form-block--input']}/>
              </div>
              {formik.errors.password && (
                <div className={styles['error']}>{formik.errors.password}</div>
              )}
            </div>
            <button disabled={spinnerFlag} type="submit" className={styles['btn']}>
              {spinnerFlag ? <GxSpinner style={{fontSize: '2rem', '--stroke-width': '6px'}}/> : 'Войти'}
            </button>
          </GxForm>
        </div>
      </div>
    </div>
  )
}

export default AuthorizationForm